export interface CatalogTundish {
  TundishId: number | null;
  TundishName: string;
  Enabled: boolean;
  IsActive: boolean;
}
export const CATALOG_TUNDISH_INITIAL_VALUES: CatalogTundish = {
  TundishId: null,
  TundishName: "",
  Enabled: true,
  IsActive: true,
};
